<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const toggleSwitch = () => {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue);
  }
};
</script>

<template>
  <div class="relative inline-flex items-center cursor-pointer" @click="toggleSwitch">
    <input 
      type="checkbox" 
      :checked="modelValue" 
      :disabled="disabled"
      class="sr-only peer" 
    />
    <div 
      class="w-9 h-5 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-n-container after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-n-brand"
      :class="{
        'bg-n-brand': modelValue,
        'bg-n-slate-3': !modelValue,
        'opacity-50 cursor-not-allowed': disabled
      }"
    ></div>
  </div>
</template>